import { render, staticRenderFns } from "./FamousPedia.vue?vue&type=template&id=66760d7d&"
import script from "./FamousPedia.vue?vue&type=script&lang=js&"
export * from "./FamousPedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports